import { render } from "./OrderDetailPage.vue?vue&type=template&id=4997fb66&scoped=true"
import script from "./OrderDetailPage.vue?vue&type=script&lang=ts"
export * from "./OrderDetailPage.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-4997fb66"

export default script